import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../components/common/BreadCrumb";
import OneTimeRecurring from "../components/OneTimeRecurring";
import RecurringRequest from "../components/RecurringRequest";
import { useDispatch, useSelector } from "react-redux";
import { getServiceSchedulingList } from "../../../redux/service/slice";

const maintabs = [
  { label: "One-Time Request" },
  { label: "Recurring Request" },
];
const Scheduling = () => {
  const [activeTabs, setActiveTabs] = useState("One-Time Request");
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [activeTab, setActiveTab] = useState("all");
  const [activeTabReccuring, setActiveTabReccuring] = useState("all");
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [technician, setTechnician] = useState("");
  const [company, setComapny] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const dispatch = useDispatch();

  // Selector
  const { getSchedulingListData, loading } = useSelector((store) => ({
    getSchedulingListData:
      store?.serviceData?.getServiceSchedulingListStatus?.data?.data,
    loading: store?.serviceData?.getServiceSchedulingListStatus?.loading,
  }));

  // getServiceSchedulingList api call
  useEffect(() => {
    dispatch(
      getServiceSchedulingList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        status: activeTab,
        technician: technician?.label || "",
        company: company?.label || "",
        recurring_status: activeTabReccuring,
        recurring_status_dropdown: selectedStatus?.value || "",
        service_request_type_id: activeTabs === "One-Time Request" ? 1 : 2,
      })
    );
  }, [
    searchValue,
    pageCount,
    pageLimit,
    activeTab,
    activeTabReccuring,
    sortBy,
    sortDirection,
    technician,
    company,
    selectedStatus,
    activeTabs,
  ]);

  return (
    <>
      <div>
        <div className="flex justify-between items-start">
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Service Request Scheduling
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={"Scheduling"}
              breadCrumbParent2={"Service Request"}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
        </div>
        <div className="flex border border-themeBtn rounded overflow-hidden mt-9">
          {maintabs.map((maintabs, index) => (
            <button
              key={maintabs.label}
              className={`py-2 px-4 uppercase text-center text-base text-themeBtn font-normal w-full transition duration-300 ${
                activeTabs === maintabs.label ? "bg-primaryOrange" : ""
              } ${index === 0 && "border-r border-theme"}`}
              onClick={() => setActiveTabs(maintabs.label)}
            >
              {maintabs.label}
            </button>
          ))}
        </div>
        {activeTabs === "One-Time Request" ? (
          <OneTimeRecurring
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            setPageLimit={setPageLimit}
            pageLimit={pageLimit}
            setPageCount={setPageCount}
            pageCount={pageCount}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            setSortBy={setSortBy}
            sortBy={sortBy}
            setSortDirection={setSortDirection}
            sortDirection={sortDirection}
            technician={technician}
            setTechnician={setTechnician}
            company={company}
            setComapny={setComapny}
            getSchedulingListData={getSchedulingListData}
            loading={loading}
          />
        ) : (
          <RecurringRequest
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            setPageLimit={setPageLimit}
            pageLimit={pageLimit}
            setPageCount={setPageCount}
            pageCount={pageCount}
            setActiveTabReccuring={setActiveTabReccuring}
            activeTabReccuring={activeTabReccuring}
            technician={technician}
            setTechnician={setTechnician}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            getSchedulingListData={getSchedulingListData}
            loading={loading}
          />
        )}
      </div>
    </>
  );
};

export default Scheduling;
